<script setup>
const emit = defineEmits(["clickEmit"])
</script>

<template>
  <div class="modal-close-btn">
    <Button
      rounded
      icon="pi pi-times"
      variant="text"
      severity="secondary"
      @click="emit('clickEmit')"
    />
  </div>
</template>

<style lang="scss">
.modal-close-btn {
  .p-button {
    .p-button-icon {
      font-size: 1.1rem;
    }
  }
}
</style>
